/*global ajaxurl */
import Qs from 'qs';
import axios from 'axios';
import Siema from 'siema';
import { practicemap } from '../practiceMap';
import AOS from 'aos';

export default {
  init() {

    /* Set the width of the side navigation to 250px and the left margin of the page content to 250px and add a black background color to body */
    function openNav() {
      var sideNav = document.getElementById('sideBarNav');
      var contentLock = document.getElementById('contentLock');
      $(contentLock).addClass('push');
      $('html').addClass('lock');
      $(sideNav).addClass('active');
    }

    /* Set the width of the side navigation to 0 and the left margin of the page content to 0, and the background color of body to white */
    function closeNav() {
      var sideNav = document.getElementById('sideBarNav');
      var contentLock = document.getElementById('contentLock');
      $(contentLock).removeClass('push');
      $('html').removeClass('lock');
      $(sideNav).removeClass('active');
    }

    $('.close-side-nav').on('click', function () {
      closeNav();
    });

    $('.open-side-nav').on('click', function () {
      openNav();
    });

    // Check if an elemnt is in viewport
    /**
     * Get Treatments by category slug
     * @param {String} category 
     */
    function getTreatments(category) {
      let data = {
        action: 'get_treatments',
        category: category,
      };
      axios
        .post(ajaxurl, Qs.stringify(data))
        .then(function (response) {
          // handle success
          var treatmentList = response.data.data.treatments;
          var treatmentListWrap = document.getElementById('treatmentLinks');

          if (treatmentList !== null) {
            treatmentList.forEach(function (item) {
              var treatmentListItem = document.createElement('li');
              treatmentListItem.innerHTML = item.link
              treatmentListWrap.append(treatmentListItem);
            });
          } else {
            treatmentListWrap.innerHTML = '<p><strong>' +
              'Please select a treatment category above.' +
              '</strong></p>';
          }
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    }

    if ($('.treatments-block').length) {
      getTreatments('all');
    }

    $('#treatmentCatNav a').on('click', function (e) {
      // Prevent Default
      e.preventDefault();

      // Set active state
      $(this).siblings().removeClass('active');
      $(this).addClass('active');

      // Clear list items
      var treatmentListWrap = document.getElementById('treatmentLinks');
      treatmentListWrap.innerHTML = '';

      // Load list items
      var treatmentType = $(this).data('treatment');
      getTreatments(treatmentType);
    });

    /**
     * Load single treatment by post ID
     * @param {Int} pid 
     */
    function loadSingletreatment(pid) {
      let data = {
        action: 'load_single_treatment',
        pid: pid,
      };
      axios
        .post(ajaxurl, Qs.stringify(data))
        .then(function (response) {
          // handle success
          var treatment = response.data.data;
          var treatmentPostDataWrap = document.getElementById('treatment-post-data');
          var treatmentTitle = treatment.title;
          var treatmentLink = treatment.link;
          var treatmentImage = treatment.image;
          var treatmentExcerpt = treatment.excerpt;
          treatmentPostDataWrap.innerHTML =
            treatmentImage + treatmentTitle + treatmentExcerpt + treatmentLink;
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    }

    $(document).on('click', '#treatmentLinks a', function (e) {
      // Prevent Default
      e.preventDefault();

      // Set active state
      $(this).parent('li').siblings().find('a').removeClass('active');
      $(this).addClass('active');

      // Clear post data
      var treatmentPostDataWrap = document.getElementById('treatment-post-data');
      treatmentPostDataWrap.innerHTML = '';

      // Load single treatment by ID
      var singletreatment = $(this).data('treatment');
      loadSingletreatment(singletreatment);
    });

    // JavaScript to be fired on all pages
    // Smooth scroll
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $('[name=" + this.hash.slice(1) + "]');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate(
              {
                scrollTop: target.offset().top - 100,
              },
              600,
              function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(':focus')) {
                  // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              }
            );
          }
        }
      });

    // Wrap header tags in a container for styling and markup
    $('.divider-header').wrap('<div class="alignfull background--gray-900"><div class="container py-3 text--white">');

    /**
     * Plot the maps with the surgeon ID
     * @param {Int} surgeonID 
     */
    function plotPraticeMap(surgeonID) {
      var mapContainer = document.querySelector('.acf-practice-map');
      var alertSpinner = document.querySelector('.alert-spinner');
      let data = {
        action: 'plot_practice_map',
        surgeonID: surgeonID,
      };
      axios
        .post(ajaxurl, Qs.stringify(data))
        .then(response => {
          response.data.data.practiceDataSet.forEach(function (marker) {
            $(alertSpinner).removeClass('active');
            var practiceMarker =
              '<div class="marker" data-lat="' +
              marker.lat +
              '" data-lng="' +
              marker.lng +
              '"><div class"marker-inner">' +
              '<p class="mb-2 lead"><strong>' + marker.title + '</strong></p>' +
              '<p>' + marker.description + '</p>' +
              '</div></div>';
            mapContainer.innerHTML += practiceMarker;
          });
          practicemap();
        })
        .catch(error => {
          console.log(error);
        });
    }

    // Default Map Plotter
    if ($('.practice-map-block').length) {
      plotPraticeMap();
    }

    // Change the filter by Surgeon
    var practiceMapFilter = $('.practice-map-filter');
    if (practiceMapFilter) {
      $('a.single-surgeon-row').on('click', function () {
        var surgeonID = $(this).data('map');
        var alertSpinner = document.querySelector('.alert-spinner');
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        $(alertSpinner).addClass('active');
        plotPraticeMap(surgeonID);
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Set padding on bdy for fixed header
    if (!$('body').hasClass('front-page-data')) {
      $(window).on('load', function () {
        var mastHeadHeight = $('#masthead').css('height');
        $('body').css('padding-top', mastHeadHeight);
        $(window).resize(function () {
          var mastHeadHeight = $('#masthead').css('height');
          $('body').css('padding-top', mastHeadHeight);
        });
      });
    }

    // When the user scrolls the page, execute myFunction 
    window.addEventListener('scroll', function () {
      if (window.scrollY >= 300) {
        headerMetaAnimationScrolled()
      } else {
        headerMetaAnimationTop();
      }
    });

    /**
     * Change the header-meta on the main nav
     */
    function headerMetaAnimationScrolled() {
      $('#masthead').addClass('minimize');
    }
    /**
     * Change the header-meta on the main nav
     */
    function headerMetaAnimationTop() {
      $('#masthead').removeClass('minimize');
    }

    /** 
     * Testimonial slider
     */
    function testimonialSlider() {
      const prev = document.querySelector('.testimonial-prev');
      const next = document.querySelector('.testimonial-next');
      const testimonialSlider = new Siema({
        selector: '.testimonial-slider',
        duration: 500,
        loop: true,
      });
      prev.addEventListener('click', () => testimonialSlider.prev());
      next.addEventListener('click', () => testimonialSlider.next());
    }

    if ($('.testimonial-slider-block').length) {
      testimonialSlider();
    }

    /** 
     * Block slider
     */
    function blockSlider() {
      const prev = document.querySelector('.block-slider-prev');
      const next = document.querySelector('.block-slider-next');
      const blockSlider = new Siema({
        selector: '.block-slider',
        duration: 500,
        loop: true,
      });
      prev.addEventListener('click', () => blockSlider.prev());
      next.addEventListener('click', () => blockSlider.next());
    }

    if ($('.slider-block').length) {
      blockSlider();
    }

    $(window).scroll(function () {
      //when window is scrolled
      var scrollTop = $(window).scrollTop();
      $('.block-slider .container, .wp-block-cover__inner-container').css({
        'margin-top': scrollTop / 3.5,
        'opacity': 1 - scrollTop / 300,
      });
    });

    /** animations */
    AOS.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js